/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
import { connect } from 'react-redux';
import { resendInvite } from '#actions/users/users.js';
import ResendInviteSubmitButton from './ResendInviteSubmitButton.jsx';

const mapDispatchToProps = (dispatch, ownProps) => {
  const { userId } = ownProps;
  return {
    resendInviteAction: () => dispatch(resendInvite(userId)),
  };
};

export default connect(null, mapDispatchToProps)(ResendInviteSubmitButton);
